import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import PhoneIcon from '@mui/icons-material/Phone';
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import Link from '@mui/material/Link';
import { HELPLINE_NUMBER } from '../../../utils/constants';

const HELP_PLAYLIST_URL = 'https://youtube.com/playlist?list=PLaDDvncthuYxxu57utCRGKdTnL65rBDZj&si=JAgHrLCIaizF7jmg';

const HelplineBar = () => {

  return (
    <Box
      sx={{
        backgroundColor: '#1976d2',
        color: 'white',
        py: 1,
        px: { xs: 1, sm: 2 },
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: { xs: 1, sm: 2 },
        width: '100%',
        zIndex: 1000,
        flexWrap: 'nowrap',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 0.5, sm: 1 } }}>
        <PhoneIcon sx={{ fontSize: { xs: 13, sm: 16 } }} />
        <Typography
          variant="body2"
          component="span"
          sx={{ fontWeight: 'bold', fontSize: { xs: '0.7rem', sm: '0.875rem' } }}
        >
          Helpline:
        </Typography>
        <Link
          href={`tel:${HELPLINE_NUMBER}`}
          sx={{
            color: 'white',
            fontWeight: 'bold',
            fontSize: { xs: '0.7rem', sm: '0.875rem' },
            textDecoration: 'none',
            '&:hover': { textDecoration: 'underline' },
          }}
        >
          {HELPLINE_NUMBER}
        </Link>
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
        <OndemandVideoIcon sx={{ fontSize: { xs: 13, sm: 16 } }} />
        <Link
          href={HELP_PLAYLIST_URL}
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            color: 'white',
            fontWeight: 'bold',
            fontSize: { xs: '0.7rem', sm: '0.875rem' },
            textDecoration: 'none',
            '&:hover': { textDecoration: 'underline' },
          }}
        >
          Help Videos
        </Link>
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
        <OpenInNewIcon sx={{ fontSize: { xs: 13, sm: 16 } }} />
        <Link
          href="https://sarathi.parivahan.gov.in/"
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            color: 'white',
            fontWeight: 'bold',
            fontSize: { xs: '0.7rem', sm: '0.875rem' },
            textDecoration: 'none',
            whiteSpace: 'nowrap',
            '&:hover': { textDecoration: 'underline' },
          }}
        >
          Sarathi Portal
        </Link>
      </Box>
    </Box>
  );
};

export default HelplineBar;
